module.exports = __webpack_public_path__ + "static/media/radiation_safety_plan_customize.5ebcc6cc.svg";